import React,{ useState } from 'react';
import { Link } from 'react-router-dom';
import { FaRegUser } from 'react-icons/fa';
import '../main.css';
import { connect } from 'react-redux';
import { logout } from '../../../../redux/actions/AuthActions';


const ModelBox = ({ auth, logout  }) => {

    const [ profile, setProfile] = useState(false);

    const handleProfile = () => {
        setProfile(!profile)
    }

    const logoutHandler = () => {
        logout()
    }

    const { authInfo } = auth;

    return (
        <div className='adminModel__btn bg-white'>
            <button type="button"  onClick={handleProfile}>
                <FaRegUser className='text-2xl' /> 
            </button>
            <div className={ profile ? "z-50 my-4 text-base sen-font list-none rounded divide-y divide-gray-100 shadow  adminDashboard__model bg-white" : "hidden my-4 text-base list-none bg-white rounded divide-y divide-gray-100 shadow " }>
            <div className="py-3 px-4 text-md text-left">
                <span className="block">{authInfo && authInfo.name }</span>
                <span className="block font-semibold truncate">{authInfo && authInfo.email}</span>
            </div>
                <ul className="py-1 text-md text-left">
                    <li>
                        <Link to='/admin/profile' className="block py-2 px-4 hover:bg-gray-100 ">Profile</Link>
                    </li>
                    <li>
                        <Link to='/admin/order' className="block py-2 px-4 hover:bg-gray-100 ">My Order</Link>
                    </li>
                    <li>
                        <button onClick={logoutHandler} className="block py-2 text-left w-full px-4 hover:text-white hover:bg-red-500 hover:text-white ">Sign out</button>
                    </li>
                </ul>
            </div>
        </div>
    )
}


const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, { logout })(ModelBox);